import { all, fork } from 'redux-saga/effects';

import { simpleRequestsLoader } from 'modules/app/utils';
import * as types from 'modules/contactMembers/actionTypes';

import detailsSaga from './details';
import {
  deleteContactMembersFailure,
  deleteContactMembersSuccess,
  updateContactMemberFailure,
  updateContactMemberSuccess,
} from '../actions/core';

/** @type {Record<string, import("modules/app/types").SimpleRequestConfig>} */
const simpleRequests = {
  [types.UPDATE_CONTACT_MEMBER]: {
    callbacks: {
      success: (payload, meta, { payload: originalPayload }) =>
        updateContactMemberSuccess({ ...payload, contactMemberId: originalPayload.contactMemberId }, meta),
      failure: (error, meta, { payload }) => updateContactMemberFailure(payload.contactMemberId, error, meta),
    },
    notifications: {
      success: {
        id: 'page.contactLists.details.contactMember.update.notification.success',
        defaultMessage: 'The contact member has been updated with success.',
      },
      failure: {
        id: 'page.contactLists.details.contactMember.update.notification.failure',
        defaultMessage: 'An error occurred while updating the contact member.',
      },
    },
  },
  [types.DELETE_CONTACT_MEMBERS]: {
    callbacks: {
      success: (payload, meta, { payload: originalPayload }) =>
        deleteContactMembersSuccess({ ...payload, contactMemberId: originalPayload.contactMemberId }, meta),
      failure: (error, meta, { payload }) => deleteContactMembersFailure(payload.contactMemberId, error, meta),
    },
    notifications: {
      success: {
        id: 'page.contactLists.details.contactMember.delete.notification.success',
        defaultMessage: 'The contact member has been deleted with success.',
      },
      failure: {
        id: 'page.contactLists.details.contactMember.delete.notification.failure',
        defaultMessage: 'An error occurred while deleting the contact member.',
      },
    },
  },
};

export default function* contactMembersSaga() {
  yield all(simpleRequestsLoader(simpleRequests));
  yield fork(detailsSaga);
}
